import { CustomTabPanel } from "@/erp/sale";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { TableSeguimientoCoste } from "../shared";
import { a11yProps, EstadoProspectoEnum, sizeTab } from "@/shared";
import { useState } from "react";


export default function SeguimientoCostePage() {
  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Seguimiento y Coste"}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs seguimiento coste"
        >
          <Tab label={'Ventas Realizadas'} {...a11yProps(0)} />
          <Tab label={'Rechazadas'} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableSeguimientoCoste
          estado_prospecto_exclude={EstadoProspectoEnum.CANCELADO}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableSeguimientoCoste
          estado_prospecto={EstadoProspectoEnum.CANCELADO}
        />
      </CustomTabPanel>

    </SingleTableBoxScene>
  )
}
